import router from '@/router/index';
import Store from '@/store/index';
import user from './modules/user';

const handleError = (dispatch, response, form = null, fieldKey = null, showToastMessage = true) => {
  dispatch(
    'handleError',
    { response, form, fieldKey, showToastMessage },
    { root: true },
  );

  if (response && response.status === 401) {
    const url = response.config.url.replace(`${response.config.baseURL}/`, '');

    if (user.state.sessionId && !['auth', 'me'].includes(url)) {
      router.push({ name: 'index' });
    } else {
      if (user.state.sessionId && url.includes('me')) {
        dispatch('logout');
      }
      router.push({ name: 'login', query: { state: router.currentRoute.fullPath } });
    }
  }
  if (response && response.status === 404) {
    Store.commit('setNotFoundError', true);
  }

  return Promise.reject(response);
};


const confirmDialog = (
  { modal, title = '', text = '', okText = 'OK', cancelText = 'Cancel', okHandler, cancelHandler },
) => {
  modal.show('dialog', {
    title,
    text,
    buttons: [
      {
        title: okText,
        handler: () => {
          modal.hide('dialog');
          if (typeof okHandler === 'function') {
            okHandler();
          }
        },
      },
      {
        title: cancelText,
        handler: () => {
          modal.hide('dialog');
          if (typeof cancelHandler === 'function') {
            cancelHandler();
          }
        },
      },
    ],
  });
};

export default {
  handleError,
  confirmDialog,
};
